import {FC, useEffect, useState} from "react";
import {Column} from "../atoms/Layout.tsx";
import LogoWithTitle from "../molecules/LogoWithTitle.tsx";
import {Text} from "../style/typography.tsx";
import {AUTH0_CLIENT} from "../helpers/auth0.ts";
import {login} from "../api/user.ts";
import {useNavigate} from "react-router";

// Error: Login Required

const LoginCallbackPage: FC = () => {
    const [error, setError] = useState<string | null>(null);

    const navigate = useNavigate()

    useEffect(() => {
        (async () => {
            await AUTH0_CLIENT.handleRedirectCallback();
            const token = await AUTH0_CLIENT.getTokenSilently({
                authorizationParams: {
                    redirect_uri: window.location.origin + "/login",
                },
                detailedResponse: true,
            });
            await login(token.id_token);
            navigate("/u/dashboard")
        })().catch(e => {
            setError(`${e}`)
        })
    }, []);

    if (error && error !== "Invalid State") return <Column padding="20" gap="80" centerVertically centerHorizontally grow>
        <LogoWithTitle />
        <Text role="heading" size="3" weight="regular">Error: {error}</Text>
    </Column>

    return <Column padding="20" gap="80" centerVertically centerHorizontally grow>
        <LogoWithTitle />
        <Text role="heading" size="5" weight="regular">Signing you in</Text>
    </Column>
}

export default LoginCallbackPage;